import { Navigate, useSearchParams } from 'react-router-dom';

// Old links and saved navigation keep working without selecting an arbitrary chat.
export default function AdminChat() {
  const [params] = useSearchParams();
  const next = new URLSearchParams(params);
  next.set('view', 'messages');
  return <Navigate to={`/admin/inbox?${next}`} replace />;
}
